import React from 'react';
import Pro01 from "../../images/services/ds/Epitomizing-Strategic.webp"
import {Col, Container, Row} from "react-bootstrap";
import {LazyLoadImage} from "react-lazy-load-image-component";

function Agile(props) {
    return (
        <div className="tekrevol_gray_bg p-100">
            <Container classNanme="h-100">
                <Row classNanme="h-100">
                    <Col xs={12} md={6} lg={6} xl={5} xxl={5}>
                        <div className="example" data-text="Research & Growth">
                            <h2>Epitomizing Strategic Research And Growth</h2>
                        </div>
                        <p>With numerous successful projects, TekRevol offers digital strategy services in helping
                            through ultimate strategy solutions for new businesses and startups to idealize and identify
                            their future plans. From strategic level guidance to tactical level assistance, our
                            consultation covers multiple aspects of digital strategy, providing you with a comprehensive
                            strategic answer for your growth path.</p>

                    </Col>
                    <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="agile_title my-auto offset-xl-1">
                        <div className="content_pointer">
                            <div className="pointers_item">
                                <div className="title_count">55+<span>Projects Completed</span></div>
                            </div>
                            <div className="pointers_item">
                                <div className="title_count">34+<span>Businesses Served</span></div>
                            </div>
                            <div className="pointers_item">
                                <div className="title_count">11+<span>Industries Covered</span></div>
                            </div>
                        </div>
                        <LazyLoadImage
                            src={Pro01}
                            effect="blur" alt="Image" className="img-fluid"
                        />
                    </Col>
                </Row>
            </Container>
        </div>
    );
}

export default Agile;